import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { bankCardMobx } from '@mobxStore'
import { IonContent, IonHeader, IonModal } from '@ionic/react'
import BankCardAuthModal from '../BankCardAuthModal'
import './index.scss'

interface IProps {
  payRechargeFlag?: boolean;
  bankCards?: any[];
  selectedCard: any;
  resolve?: (data: any) => void;
  reject?: () => void;
}

const SelectBankCardModal: FC<IProps> = ({ payRechargeFlag, bankCards, selectedCard, resolve, reject }) => {
  bankCards = bankCards || bankCardMobx?.memberBankCards

  const onSelect = (card: any) => {
    resolve(card)
  }

  const onAuth = async () => {
    const card: any = await modalLayer(BankCardAuthModal, { payRechargeFlag, multiUse: true }, 'bankCardAuthModal')
    onSelect({
      type: 'bankCardOnline',
      id: card.creditCardNo,
      number: card.creditCardNumber,
    })
  }

  return (
    <IonModal
      isOpen
      cssClass='mall-select-bank-card-modal height620-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='select-bank-card-header'>
          <span>{i18n.t('pay.selectBankCard')}</span>
          <i className='iconfont icon-close' data-cypid='mallBankCardModalClose' onClick={reject} />
        </div>
      </IonHeader>
      <IonContent>
        <ul className='bank-card-list'>
          {bankCards?.map(x => (
            <li
              key={x.id}
              className={classNames('bank-card-item', { selected: selectedCard && x.id === selectedCard.id })}
              data-cypid={`mallBankCardItem_${x?.id}`}
              onClick={() => onSelect(x)}
            >
              <span className='card-number'>{format.maskCardNumber(x.number)}</span>
              {x.lastUsed && <span className='last-used'>{i18n.t('pay.lastUsed')}</span>}
              <i className={classNames('iconfont', selectedCard && x.id === selectedCard.id ? 'icon-checked' : 'icon-circle')} />
            </li>
          ))}
          <li className='bank-card-item' data-cypid='mallBankCardModalAdd' onClick={onAuth}>
            <span className='add-bank-card'>{i18n.t('pay.addBankCard')}</span>
            <i className='iconfont icon-chevron-right' />
          </li>
        </ul>
      </IonContent>
    </IonModal>
  )
}

export default observer(SelectBankCardModal)
